export const FINANCE_FORM_INPUT_KEY = 'au_sub-dis_finance_form_input';
export const FINANCE_FORM_INPUT_LAST_FINANCE_KEY =
  'au_sub-dis_finance_form_input_last_finance';

export const DEFAULT_FINANCE_FORM_INPUT = {
  paymentType: 'finance',
  financeProductId: 'FIN_PROD_AUS_SUB_GFV',
  mileage: 15000,
  financePackageId: 'Weekly',
  deposit: 0,
  term: 60,
  ageRange: '23',
  homeOwner: 'true',
  creditRating: 'VERY_GOOD',
};

/**
 * Reads the live finance form input from localStorage. If it's finance-typed,
 * snapshots it as the "last known finance input" and returns it. Otherwise
 * (e.g. the Configurator switched payment type to Cash) falls back to that
 * snapshot. Returns null if neither is available, so callers can apply their
 * own default.
 */
export const readStoredFinanceFormInput = (): any | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const storedInput = localStorage.getItem(FINANCE_FORM_INPUT_KEY);
  if (!storedInput) {
    return null;
  }

  const parsedInput = JSON.parse(storedInput);
  if (parsedInput && parsedInput.paymentType === 'finance') {
    localStorage.setItem(
      FINANCE_FORM_INPUT_LAST_FINANCE_KEY,
      JSON.stringify(parsedInput)
    );
    return parsedInput;
  }

  const lastFinanceInput = localStorage.getItem(
    FINANCE_FORM_INPUT_LAST_FINANCE_KEY
  );
  return lastFinanceInput ? JSON.parse(lastFinanceInput) : null;
};

/**
 * Ensures the live finance form input key in localStorage is finance-typed
 * before the FC repayment widget initializes - it reads this key directly,
 * so restoring it here (from the last known finance input, or the hardcoded
 * default) is what makes the widget open pre-filled instead of showing its
 * own built-in defaults.
 */
export const ensureLiveFinanceFormInputForWidget = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const storedInput = localStorage.getItem(FINANCE_FORM_INPUT_KEY);
  const parsedInput = storedInput ? JSON.parse(storedInput) : null;
  if (parsedInput && parsedInput.paymentType === 'finance') {
    return;
  }

  const lastFinanceInput = localStorage.getItem(
    FINANCE_FORM_INPUT_LAST_FINANCE_KEY
  );
  const financeFormInput = lastFinanceInput
    ? JSON.parse(lastFinanceInput)
    : DEFAULT_FINANCE_FORM_INPUT;

  localStorage.setItem(
    FINANCE_FORM_INPUT_KEY,
    JSON.stringify(financeFormInput)
  );
};
